const mime = {
  'doc': 'application/msword',
  'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'pdf': 'application/pdf',
  'xls': 'application/vnd.ms-excel',
  "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  'bmp': 'image/bmp',
  'gif': 'image/gif',
  'jpeg': 'image/jpeg',
  'jpg': 'image/jpeg',
  'png': 'image/png',
  'txt': 'text/plain',
  'xml': 'text/xml',
}

export const isType = (type) => (obj) => (Object.prototype.toString.call(obj) === `[object ${type}]`)

export const isArray = isType('Array')

export const isObject = isType('Object')

export const isBlob = isType('Blob')

export const isString = isType('String')

export const isNumber = isType('Number')

export const isFunction = isType('Function')

export const map = (data, key = 'key', value) => {
  let obj = {}
  data.forEach(i => {
    if (key in i) {
      obj[i[key]] = value ? i[value] : i
    }
  })

  return obj
}

export const rnd = (a, b , pad = 0) => Math.round(a + Math.random() * (b - a)).toString().padStart(pad,0)

export const values = (obj) => {
  let arr = []
  for (let i in obj) {
    arr.push(obj[i])
  }
  return arr
}

export const unique = (arr, key) => values(hash(arr, key))

export const pick = (arr, key) => Array.from(new Set(arr.map(i => i[key])))

// 平面结构转树
export const tree = (data, fieldId = 'id', parentId = 'parentId', children = 'children', rootId = 0) => {
  let obj = map(data, fieldId),
    root = []

  data.forEach(i => {
    let pid = i[parentId],
      id = i[fieldId]
    if (pid == rootId) {
      root.push(i)
    } else {
      if (obj[pid]) {
        if (!obj[pid][children]) {
          obj[pid][children] = []
        }
        obj[pid][children].push(i)
      }
    }
  })

  //查找root
  if(root.length == 0){
    for(let i in obj){
      if(!obj[obj[i].parentId]){
        root.push( obj[i] )
      }
    }
  }

  return root
}


export const fill = (dist, src, u = false) => {
  let empty = !src
  let ksrc = u ? src : dist
  for (let i in ksrc) {
    if (empty) {
      dist[i] = ''
    } else {
      if (src.hasOwnProperty(i)) {
        dist[i] = src[i]
      }
    }
  }
}

export const valid = (dist, src) => {
  for (let i in src) {
    if (!dist[i]) {
      dist[i] = src[i]
    }
  }
  return dist
}

export const flat = (data) => {
  if (isArray(data, 'Array')) {
    data.forEach(i => {
      flat(i)
    })
  } else if (isObject(data, 'Object')) {
    for (let i in data) {
      if (isObject(data[i], 'Object')) {
        let key = i
        for (let j in data[i]) {
          data[i + '.' + j] = data[i][j]
        }
      } else {

      }
    }
  } else {

  }

  return data
}

export const getBlob = (url, filename) => {
  let blob
  try {
    let ext = fileName.split('.').slice(-1)
    blob = new Blob([blob], { type: mime[ext] })
  } catch (e) {

  }
  return blob
}

export const saveFile = (blob, fileName) => {
  if (isObject(blob)) {
    if(blob.headers && blob.headers['content-type'] && blob.headers['content-type'].includes('application/json')){
      return saveJSON(blob.data)
    }
    if (isBlob(blob.data)) {
      if (blob.headers && blob.headers['content-disposition']) {
        if (!fileName)
          fileName = decodeURIComponent(blob.headers['content-disposition'].split('filename=')[1].replace(/"/g, ''))
      }
      blob = blob.data
    }
  }

  if (isString(blob)) {
    blob = getBlob(blob, fileName)
  }

  if (isBlob(blob)) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, fileName)
    } else {
      const URL = window.URL || window.webkitURL

      var link = document.createElement('a')

      link.href = URL.createObjectURL(blob)
      link.download = fileName

      var evt = document.createEvent("MouseEvents")
      evt.initEvent("click", false, false);
      // link.click()
      link.dispatchEvent(evt);
      URL.revokeObjectURL(link.href)
    }
  }

  return Promise.resolve()
}

export const saveJSON = (blob) => new Promise((resolve , reject)=>{
  if(isBlob(blob)){
    let reader = new FileReader()
    reader.onload = e => {
      resolve( JSON.parse(e.target.result) )
    }
    reader.readAsText(blob)
  }else{
    resolve({msg:'数据无法解析'})
  }
})

export const pipeline = (...funs) => val => funs.reduce((a, b) => b(a), val)

export const tpl = (t, d) => t.replace(/\{([\w\W]+?)\}/g, (str, key) => {
  let value = d[key];
  if (value === undefined) {
    value = "{" + key + "}";
  } else if (typeof value === 'function') {
    value = value(data);
  }
  return value;
})


export const idCard = () => {
  let id = '33010' + rnd(1,9) + rnd(1900,2018) + rnd(1,12,2) + rnd(1,30,2) + rnd(1,999,3)
  return id + "10X98765432".charAt( id.split('').reduce( (t , c, i) =>( t + parseInt(c) * (parseInt('68947310526894731'.charAt(i))+1)) ,0) % 11 )
} 

export const throttle = (method, delay = 100, duration = 200) => {
  let timer = null
  let begin = Date.now()
  return () => {
    let context = this, args = arguments
    let current = Date.now()
    clearTimeout(timer);
    if (current - begin >= duration) {
      method.apply(context, args);
      begin = current;
    } else {
      timer = setTimeout(() => {
        method.apply(context, args)
      }, delay)
    }
  }
}